import React from 'react';
import Table from "../ServicesTable/ServicesTable";
import './ManagementServices.scss'
import { Container, Row,Col } from 'react-bootstrap';

const ManagementServices =({Module}) => {

    //console.log("Module ==>", Module)

    const theadData = Module?.table_section?.table_header?.map(item => item)

    let tbodyData = [];
    Module?.table_section?.table_body?.map((item) => {
        if(item){
            tbodyData.push({id:item.id, items:Object.values(item)})
        }
    })

    //console.log("table_bottom_cta", Object.values(Module?.table_section?.table_bottom_cta))

    const tfooterData = Module?.table_section?.table_bottom_cta ? Object.values(Module?.table_section?.table_bottom_cta) : "";

    return (
        <div className='management-services' id="management-services">
         
            <Container>
            <Row>
                <Col xs="12">
                    <div className='heading-block text-center'>
                        <h2>{Module.title}</h2>
                        <p>{Module.content}</p>
                    </div>
                </Col>
            </Row>
                <Row>
                    <Col xs="12">
                        <div className="services-table">
                            
                            <Table customClass={"table"} theadData={theadData} tbodyData={tbodyData} tfooterData={tfooterData} />
                           
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
     
    
}

export default ManagementServices;
